import axios from 'axios';
import _ from 'lodash';
import { getNotificationsQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';
import Split from '../split';

const getNotifications = (id) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const query = getNotificationsQuery({ userId: id, limit: '250', queryBuilder });
        const request = axios.get(query);

        request
            .then((response) => {
                const notifications = response.data;
                // Express returns _id; normalize to id so NotificationCenter
                // can build the PATCH URL with notification.id.
                if (useExpress) {
                    renameKey(notifications, '_id', 'id');
                }
                const data = _.map(notifications, (notification) => ({ status: _.includes(notification.read_status, id), ...notification }));
                resolve({ notifications: data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getNotifications;
